/**
 * Created by antonio on 30/01/15.
 */
define('boxes/helpers/payment-helpers',['jquery', 'all/comeon', 'payment/templates/form-template', 'payment/templates/payment-controller', 'boxes/events/feeEvent', 'boxes/helpers/formValidation', 'boxes/helpers/uk-deposit-limit'], function($, comeon, formTemplate, paymentController, feeEvent, formValidation, ukDepositLimit) {
    'use strict';

    function getPaymentMethods(paymentType, paymentBox, flowUrl, forceLoadInSynch) {
        paymentBox.model.paymentController = undefined;

        var hasPaymentMethodsPromise = comeon.promise.create();
        $.get(flowUrl, {forceLoadInSynch: forceLoadInSynch, isMobileDevice: false}, function (data) {
			console.info('getPaymentMethods From Server: ');
			console.info(data);
            paymentBox.model.paymentController = paymentController.create(paymentType, data);
            hasPaymentMethodsPromise.resolve();
        });

        return hasPaymentMethodsPromise.promise();
    }

    function initFormTemplate(paymentBox) {
        var initPromise = comeon.promise.create();
        paymentBox.model.paymentController.initSelectedFormTemplate(initPromise);
        paymentBox.$box.find('.payment-method-form').addClass('ui-animation fade-in duration5');
        return initPromise.promise();
    }

    function initSelectedFormTemplate(paymentBox, hasPaymentMethodsPromise) {
        var initPromise = comeon.promise.create();
        $.when(hasPaymentMethodsPromise)
            .done(function() {
                paymentBox.model.paymentController.initSelectedFormTemplate(initPromise);
                paymentBox.$box.find('.payment-method-form').addClass('ui-animation fade-in duration5');
            }
        );
        return initPromise.promise();
    }

    function setupDefaultMethodDropdown(paymentBox) {
        getDropdownSelect(paymentBox).val(paymentBox.model.paymentController.selectedFormMethodId).change();
    }

    function setupDefaultAmountForMethod(paymentBox) {
        getAmountInputField(paymentBox).val(paymentBox.model.paymentController.selectedAmount).change();
    }

    function setupDefaultPaymentMethod(paymentBox) {
        setupDefaultMethodDropdown(paymentBox);
        setupDefaultAmountForMethod(paymentBox);
    }

    function setupUIEventHandlers(paymentBox) {
        setupDropdownOnClick(paymentBox);
        setupDropdownOnChange(paymentBox);
        setupAmountFieldOnChange(paymentBox);
        setupAmountFieldOnKeyup(paymentBox);
        setupAmountButtonsOnClick(paymentBox);
		blockBadCharactersInAmountField(paymentBox);
		blockBadCharactersInLimitField(paymentBox);
    }

    function setupDropdownOnClick(paymentBox) {
        var $imgDiv = getDropdownSelectImgDiv(paymentBox);
        $imgDiv.off('click').on('click', function () {
            openDropdownSelection(paymentBox.$box.find('.form-group.method .form-control'));
        });
    }

    function setupDropdownOnChange(paymentBox) {
        var $paymentMethodSelectionBox = paymentBox.$box.find('select.payment-methods');
        $paymentMethodSelectionBox.off('change').on('change', function () {
            var controller = paymentBox.model.paymentController;
            controller.selectedCurrency = undefined;
            controller.selectedFormMethodId = parseInt($(this).val());
            var hasInitSelectedFormTemplatePromise = initFormTemplate(paymentBox);
            renderBox(paymentBox, hasInitSelectedFormTemplatePromise);
        });
    }

    function setupAmountFieldOnChange(paymentBox) {
        var $amountInputField = getAmountInputField(paymentBox);
        $amountInputField.off('change input').on('change input', function () {
            feeEvent.updateFeeWithAmount(paymentBox, this.value);
			if (ukDepositLimit.depositLimitChosen()) {
				ukDepositLimit.checkForLimitDepositError(paymentBox);
			}
        });
    }

	function blockBadCharactersInAmountField(paymentBox) {
		var $amountInputField = getAmountInputField(paymentBox);
		$amountInputField.keypress(function (event) {
			var BACKSPACE = 8;
			var TAB = 9;
			var chr = String.fromCharCode(event.which);
			if ('1234567890,.'.indexOf(chr) < 0 && [BACKSPACE, TAB].indexOf(event.keyCode) < 0) {
				return false;
			}
		});
	}

	function blockBadCharactersInLimitField(paymentBox) {
		var $limitInputField = getLimitInputField(paymentBox);
		$limitInputField.keypress(function (event) {
			var BACKSPACE = 8;
			var TAB = 9;
			var chr = String.fromCharCode(event.which);
			if ('1234567890,.'.indexOf(chr) < 0 && [BACKSPACE, TAB].indexOf(event.keyCode) < 0) {
				return false;
			}
		});
	}

    function setupAmountFieldOnKeyup(paymentBox) {
        var $amountInputField = getAmountInputField(paymentBox);
        $amountInputField.on('keyup', function (e) {
			var amount = e.target.value;
			amount = amount.replace(/,/g, '.');

			var decimals = amount.match(/[.]/g);
			if(decimals !== null && decimals.length > 1){
				amount = amount.substring(0,amount.length-1);
			}
            var maxPlaces = 2,
                integer = e.target.value.split('.')[0],
                mantissa = e.target.value.split('.')[1];
            if (typeof mantissa === 'undefined') {
                mantissa = '';
            }
            if (mantissa.length > maxPlaces) {
                amount = integer + '.' + mantissa.substring(0, 2);
            }
			e.target.value = amount;
        });
    }

    function setupAmountButtonsOnClick(paymentBox) {
        var $amountButtons = paymentBox.$box.find('.btn');
        $amountButtons.off('click').on('click', function () {
            var $activeButton = $amountButtons.filter('.active');
            $activeButton.removeClass('active');
            var $clickedButton = $(this);
            $clickedButton.addClass('active');

            var amount = $clickedButton.find('input').val();
            var $amountInputField = getAmountInputField(paymentBox);
            $amountInputField.val(amount).change();
        });
    }

    function getAmountInputField(paymentBox) {
        return paymentBox.$box.find('.amount-box input');
    }

	function getLimitInputField(paymentBox) {
		return paymentBox.$box.find('.daily-limit input');
	}

    function getDropdownSelect(paymentBox) {
        return paymentBox.$box.find('select.payment-methods');
    }

    function getDropdownSelectImgDiv(paymentBox) {
        return paymentBox.$box.find('.form-group.method div.img');
    }

    function openDropdownSelection(element) {
        if (document.createEvent) {
            var e = document.createEvent("MouseEvents");
            e.initMouseEvent("mousedown", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            element[0].dispatchEvent(e);
        } else if (element.fireEvent) {
            element[0].fireEvent("onmousedown");
        }
    }

    function renderBox(paymentBox, hasInitSelectedFormTemplatePromise) {
        var controller = paymentBox.model.paymentController;
        var selectedFormTemplate = controller.getSelectedFormTemplate();
        $.when(hasInitSelectedFormTemplatePromise)
            .done(function() {

                paymentBox.$box.find('.payment-method-form').hide();

                var selectedFormLogoImgClasses = selectedFormTemplate.paymentMethod.logoImgClasses;
                var $selectionImgDiv = getDropdownSelectImgDiv(paymentBox);
                changeSelectionImgLogos($selectionImgDiv, selectedFormLogoImgClasses);

                controller.renderSelectedFormTemplate(paymentBox);

				// TODO: Refactor fee handling. Fee initialization is sending lots of events, late resetFee may come an overwrite updated fee
				feeEvent.updateFee(paymentBox);
				setTimeout(function () {
					feeEvent.updateFee(paymentBox);
				}, 1500);
				setTimeout(function () {
					feeEvent.updateFee(paymentBox);
				}, 3000);

            }
        );
    }

    function changeSelectionImgLogos($selectionImgDiv, selectedLogoClasses) {
        $selectionImgDiv.empty();

        for(var i = 0; i < selectedLogoClasses.length; i++) {
            var logoDiv = document.createElement('div');
            $(logoDiv).addClass('method-logo').addClass(selectedLogoClasses[i]).appendTo($selectionImgDiv);
        }
    }

    function isHTML(content) {
        return /<(br|basefont|hr|input|source|frame|param|area|meta|!--|col|link|option|base|img|wbr|!DOCTYPE).*?>|<(a|abbr|acronym|address|applet|article|aside|audio|b|bdi|bdo|big|blockquote|body|button|canvas|caption|center|cite|code|colgroup|command|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frameset|head|header|hgroup|h1|h2|h3|h4|h5|h6|html|i|iframe|ins|kbd|keygen|label|legend|li|map|mark|menu|meter|nav|noframes|noscript|object|ol|optgroup|output|p|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|var|video).*?<\/\2>/i.test(content);
    }

    function updateTextOrHtml($element, value){
        if (isHTML(value)) {
            $element.html(value);
        } else {
            $element.text(value);
        }
    }

    var paymentsHelper  = {};
    paymentsHelper.getPaymentMethods = getPaymentMethods;
    paymentsHelper.initSelectedFormTemplate = initSelectedFormTemplate;
    paymentsHelper.setupDefaultPaymentMethod = setupDefaultPaymentMethod;
    paymentsHelper.setupDefaultMethodDropdown = setupDefaultMethodDropdown;
    paymentsHelper.setupDefaultAmountForMethod = setupDefaultAmountForMethod;
    paymentsHelper.setupUIEventHandlers = setupUIEventHandlers;
    paymentsHelper.getAmountInputField = getAmountInputField;
    paymentsHelper.getDropdownSelect = getDropdownSelect;
    paymentsHelper.getDropdownSelectImgDiv = getDropdownSelectImgDiv;
    paymentsHelper.renderBox = renderBox;
    paymentsHelper.isHTML = isHTML;
    paymentsHelper.updateTextOrHtml = updateTextOrHtml;
    return paymentsHelper;
});

